import { type ReactNode, useEffect, useState } from 'react';

import { subscribeToRecordingActive } from '@/shared/lib/cross-tab-recording-signal';
import { InactivityTimer } from '@/shared/lib/inactivity-timer';
import { InactivityTimerContext } from '@/shared/lib/inactivity-timer-context';

export function InactivityTimerProvider({ children }: { children: ReactNode }) {
    const [inactivityTimer] = useState(new InactivityTimer());

    useEffect(() => {
        inactivityTimer.init();
        return () => inactivityTimer.destroy();
    }, [inactivityTimer]);

    useEffect(() => {
        return subscribeToRecordingActive((active) => {
            if (active) {
                inactivityTimer.stop();
            } else {
                inactivityTimer.start();
            }
        });
    }, [inactivityTimer]);

    return <InactivityTimerContext value={inactivityTimer}>{children}</InactivityTimerContext>;
}

export { useInactivityTimer } from '@/shared/lib/inactivity-timer-context';
